export const appConstants = {
  TIME_OUT: 1000,
};
